/* esm.sh - mdast-util-gfm@3.1.0 */
export * from "/*mdast-util-gfm@3.1.0/esnext/mdast-util-gfm.mjs";
